import { useEffect } from "react";

const RoundtableAppLanding = () => {
  // navigate default page to lanceboard.com
  useEffect(() => {
    window.location.replace(process.env.REACT_APP_GATHERLANCE_URL);
  }, []);

  return <></>;
};

export default RoundtableAppLanding;
